import { render } from "./HelpWindow.vue?vue&type=template&id=06838e42&scoped=true"
import script from "./HelpWindow.vue?vue&type=script&lang=js"
export * from "./HelpWindow.vue?vue&type=script&lang=js"

import "./HelpWindow.vue?vue&type=style&index=0&id=06838e42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06838e42"]])

export default __exports__